// Validation de toutes les étapes, recalculée à chaque saisie. La navigation
// entre étapes reste libre ; seule la soumission exige un dossier complet.

const PHONE = /^(\+235)?[0-9]{8}$/;
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const WORD_EXT = ['.doc', '.docx'];
const SCAN_EXT = ['.pdf', '.jpg', '.jpeg', '.png'];
const MAX_FILE_SIZE = 5 * 1024 * 1024;

export const FIELD_STEP = {
  nom: 1, prenoms: 1, sexe: 1, date_naissance: 1, telephone: 1, telephone_2: 1, email: 1,
  domaine_formation: 2, niveau_etude: 2, diplome_obtenu: 2,
  experience_enquetes_menages: 3, annees_experience: 3, roles_enquetes: 3, operations: 3,
  experience_gestion_equipes: 3, nombre_agents_encadres: 3, outils_collecte: 3,
  engagement_ethique: 4,
  cv: 5, lettre_motivation: 5, diplome_fichier: 5, piece_identite: 5,
};

export const FIELD_LABELS = {
  nom: 'Nom', prenoms: 'Prénoms', sexe: 'Sexe', date_naissance: 'Date de naissance',
  telephone: 'Téléphone 1', telephone_2: 'Téléphone 2', email: 'E-mail',
  domaine_formation: 'Domaine', niveau_etude: 'Niveau', diplome_obtenu: 'Intitulé du diplôme',
  experience_enquetes_menages: 'Expérience enquêtes ménages', annees_experience: "Années d'expérience",
  roles_enquetes: 'Rôles tenus', operations: 'Enquêtes réalisées',
  experience_gestion_equipes: "Gestion d'équipes", nombre_agents_encadres: 'Agents encadrés',
  outils_collecte: 'Outils de collecte',
  engagement_ethique: 'Engagement',
  cv: 'CV', lettre_motivation: 'Lettre de motivation', diplome_fichier: 'Diplôme',
  piece_identite: "Pièce d'identité",
};

const age = (isoDate) => {
  const birth = new Date(isoDate);
  const today = new Date();
  let a = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) a -= 1;
  return a;
};

const checkFile = (file, allowed) => {
  if (!file) return 'Fichier obligatoire.';
  const ext = file.name.toLowerCase().slice(file.name.lastIndexOf('.'));
  if (!allowed.includes(ext)) return `Format non accepté (${allowed.join(', ')}).`;
  if (file.size > MAX_FILE_SIZE) return 'Fichier trop volumineux (5 Mo max).';
  return null;
};

export const validateAll = (d) => {
  const e = {};
  const required = (field, msg = 'Obligatoire.') => {
    const v = d[field];
    if (v === null || v === undefined || (typeof v === 'string' && !v.trim()) || (Array.isArray(v) && v.length === 0)) {
      e[field] = msg;
      return false;
    }
    return true;
  };
  const phone = (field) => {
    if (required(field) && !PHONE.test(d[field].trim())) e[field] = '8 chiffres, ex. 66123456.';
  };

  // 1. Identité
  required('nom');
  required('prenoms');
  required('sexe');
  if (required('date_naissance') && age(d.date_naissance) < 18) e.date_naissance = 'Vous devez avoir au moins 18 ans.';
  phone('telephone');
  if (d.telephone_2 && d.telephone_2.trim() && !PHONE.test(d.telephone_2.trim())) {
    e.telephone_2 = '8 chiffres, ex. 66123456.';
  }
  if (d.email && d.email.trim() && !EMAIL.test(d.email.trim())) e.email = 'Adresse e-mail invalide.';

  // 2. Formation — critère 1
  if (required('domaine_formation') && d.domaine_formation === 'autre') {
    e.domaine_formation = 'Diplôme de statisticien ou de démographe requis.';
  }
  required('niveau_etude');
  required('diplome_obtenu');

  // 3. Expérience — critères 2, 3, 4
  if (required('experience_enquetes_menages')) {
    if (!d.experience_enquetes_menages) {
      e.experience_enquetes_menages = 'Cette expérience est obligatoire pour le poste.';
    } else {
      if (!d.annees_experience) e.annees_experience = 'Obligatoire.';
      required('roles_enquetes', 'Sélectionnez au moins un rôle.');
      required('operations', 'Sélectionnez au moins une enquête.');
    }
  }
  if (required('experience_gestion_equipes')) {
    if (!d.experience_gestion_equipes) {
      e.experience_gestion_equipes = 'Cette expérience est obligatoire pour le poste.';
    } else if (!d.nombre_agents_encadres) {
      e.nombre_agents_encadres = 'Obligatoire.';
    }
  }
  required('outils_collecte', 'Au moins un outil est obligatoire.');

  // 4. Compétences
  if (!d.engagement_ethique) e.engagement_ethique = 'Engagement requis.';

  // 5. Documents
  [['cv', WORD_EXT], ['lettre_motivation', WORD_EXT], ['diplome_fichier', SCAN_EXT], ['piece_identite', SCAN_EXT]]
    .forEach(([field, allowed]) => {
      const msg = checkFile(d[field], allowed);
      if (msg) e[field] = msg;
    });

  return e;
};

export const errorsByStep = (errors) => {
  const byStep = {};
  Object.keys(errors).forEach((field) => {
    const step = FIELD_STEP[field] || 1;
    (byStep[step] = byStep[step] || []).push(field);
  });
  return byStep;
};
